import { defineComponent as l, computed as n, useAttrs as o, openBlock as r, createElementBlock as c, mergeProps as d, unref as s } from "vue";
import { useIllustrationOptimizer as m } from "@ds/plugin";
import { omit as u } from "../../utils/omit.js";
const g = ["alt", "decoding", "height", "loading", "sizes", "src", "srcset", "width"], v = /* @__PURE__ */ l({
  name: "RevIllustration",
  /**
   * Do not automatically inherit attributes so that we can intercept them
   * and extract what we do not want to apply (in our case `srcset`).
   */
  inheritAttrs: !1,
  __name: "Illustration",
  props: {
    src: {},
    alt: {},
    height: {},
    width: {},
    loading: { default: "lazy" },
    decoding: { default: "async" },
    sizes: { default: "100vw" },
    imageClassNames: { default: "h-auto max-h-full max-w-full leading-none" }
  },
  setup(t) {
    const i = t, e = m(() => i.src), a = n(() => u(o(), ["srcset"]));
    return (h, f) => (r(), c("img", d(a.value, {
      alt: t.alt,
      class: t.imageClassNames,
      decoding: t.decoding,
      height: t.height,
      loading: t.loading,
      sizes: t.sizes,
      src: s(e).src,
      srcset: s(e).srcset,
      width: t.width
    }), null, 16, g));
  }
});
export {
  v as default
};
